module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section_bg-8254e66085f8d41285a40ff8fe17501a.png";